import { useGetGuestsiteTidbitsQuery } from './TidbitsList.graphql.generated';
import { useEventUserRole } from '@shared/components/AuthProvider';
import { useIsCurrentPageSsrFetchEnabled } from '@apps/guest/shared/hooks/useIsCurrentPageSsrFetchEnabled';
import { isInIframe } from '@shared/utils/isInIframe';

export const useFetchTidbitsListData = (eventHandle: string, skip?: boolean) => {
  const { isAdmin } = useEventUserRole();
  const isPreviewing = isInIframe();
  const isSsrEnabled = useIsCurrentPageSsrFetchEnabled(eventHandle, 'tidbits');

  const { data, loading } = useGetGuestsiteTidbitsQuery({
    variables: { eventHandle, isAdminDashboard: isPreviewing && isAdmin },
    batchMode: 'fast',
    ssr: isSsrEnabled,
    skip,
  });

  return { data, loading };
};
